<template>
  <UiBtn
    v-show="!userHide || !isLoggedIn"
    :data-id="dataId"
    :text="c_text"
    :color="c_color"
    size="l"
    v-bind="$attrs"
    :full-width="fullWidth"
    @click="onNavigate"
  />
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BaseAuthOrRegister',
  props: {
    text: { type: String }, // default = $t('registration'), provide only it if you want the same user text and guest text
    color: { type: String, default: 'primary' },
    /** user props */
    userText: { type: String }, // text when isLoggedIn, if undefined 'text' prop will be used
    userTo: { type: [String, Object] },
    userColor: { type: String },
    userHide: { type: Boolean },
    /** other */
    dataId: { type: String },
    fullWidth: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters('user', { isLoggedIn: 'isLoggedIn' }),
    c_text() {
      if (this.userText && this.isLoggedIn) return this.userText
      return this.text ? this.text : this.$t('registration')
    },
    c_color() {
      return Boolean(this.isLoggedIn && this.userColor)
        ? this.userColor
        : this.color
    },
  },
  methods: {
    onNavigate() {
      this.$emit('click')
      if (!this.isLoggedIn) {
        
        this.$newModal.openAuthOrRegister()
      }
      else {
        if (this.userTo) this.$router.push(this.userTo)
        this.$emit('user-click')
      }
    },
  },
}
</script>
